import type { EquipmentAccessorialType } from './constants.ts'
import { createEquipmentCategory } from './internal.ts'

const flatbedAccessorials: EquipmentAccessorialType[] = [
  'tarps',
  'chains',
  'pipe-stakes',
  'straps',
  'team-driver',
  'tanker-endorsement',
  'oversize-overweight',
]

export const flatbedEquipment = createEquipmentCategory(
  {
    bucket: 'flatbed',
    mode: 'truckload',
    workflows: ['truckload'],
    accessorialTypes: flatbedAccessorials,
  },
  [
    { key: 'flatbed-53', name: "Flatbed 53'" },
    { key: 'flatbed-48', name: "Flatbed 48'" },
    { key: 'step-deck', name: 'Step deck' },
    { key: 'flatbed-lowboy', name: 'Lowboy' },
    { key: 'crazy8-flatbed', name: 'Crazy 8 flatbed' },
    { key: 'flatbed-48-double-drop', name: "Flatbed 48' double drop" },
    { key: 'flatbed-48-step', name: "Step deck 48'" },
    { key: 'flatbed-53-step', name: "Step deck 53'" },
    { key: 'flatbed-b-train', name: 'Flatbed B-train' },
    { key: 'flatbed-heavy-haul', name: 'Flatbed heavy haul' },
    {
      key: 'flatbed-removable-gooseneck(rgn)',
      name: 'Gooseneck Trailer',
    },
    { key: 'flatbed-self-unloader', name: 'Flatbed self unloader' },
    { key: 'flatbed-with-piggyback', name: 'Flatbed with piggyback' },
    { key: 'flatbed-tri-axle', name: 'Flatbed tri axle' },
    {
      key: 'hotshot',
      name: 'Hotshot',
      workflows: ['truckload', 'ltl'],
    },
    {
      key: 'partial-flatbed',
      name: 'Partial flatbed',
      workflows: ['truckload', 'ltl'],
    },
    { key: 'conestoga', name: 'Conestoga' },
  ],
)
